<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="金币明细"
        right-text="使用帮助"
        left-arrow
        @click-left="goBack"
        @click-right="onClickRight"
      />
    </van-sticky>
    <div class="page">
      <div class="title">
        <span class="title-name">已获得金币总数</span>
        <div class="acquire">
          <div class="number">
            <span style="color: #dd2437">+ {{ accountMsg.total }} </span>
          </div>
          <img src="@/assets/images/gold-coin/gong_gold.png" alt="" />
        </div>
        <span class="title-name">已使用金币总数</span>
        <div class="acquire">
          <div class="number">
            <span style="color: #8bc53f">- {{ accountMsg.totalUsed }} </span>
          </div>
          <img src="@/assets/images/gold-coin/gong_gold.png" alt="" />
        </div>
      </div>
    </div>
    <div style="height: 60px; border-bottom: 1px solid #eeeeee"></div>
    <van-sticky>
      <div class="screen">
        <van-dropdown-menu>
          <van-dropdown-item
            @change="recordChange"
            v-model="recordValue"
            :options="recordOption"
          />
          <van-dropdown-item
            v-model="timeValue"
            @change="timeChange"
            :options="timeOption"
          />
        </van-dropdown-menu>
      </div>
    </van-sticky>
    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :error.sync="error"
          :finished="finished"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <!-- <div class="list-time">本月</div> -->
          <div v-for="(item, index) in goldList" :key="index">
            <div class="list-header">
              <div class="list-detail">
                <p>{{   item.source | sourceName(item.type) }}</p>
                <p v-if="item.source === 0 || item.source === 3">
                  订单号：{{ item.entityId }}
                </p>
                <p>{{ getTime(item.dateCreated) }}</p>
              </div>
              <div class="list-mun">
                <span v-if="item.type === 0" style="color: #dd2437"
                  >+{{ item.count }}</span
                >
                <span v-else style="color: #8bc53f">-{{ item.count }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { list, account } from '@/api/gold-coin'
import { parseTime } from '@/utils'
import moment from 'moment'
export default {
 filters: {
    sourceName(num, type) {
      // 购物获得折上折金币                       购物0+收入0
      // 购物使用折上折金币                       购物0+支出1
      // 参与平台活动获得折上折金币          活动1+收入0
      // 退款成功，返还金币                       退款3+收入0
      // 折上折金币提现                              提现2+支出1
      console.log('num', num, 'type', type);
      const position = [
        ['购物获得折上折金币', '购物使用折上折金币'],
        ['参与平台活动获得折上折金币'],
        ['', '折上折金币提现'],
        ['退款成功，返还金币'],
      ]

      return position[num][type]
      // switch (num) {
      //   case 0:
      //     return '购物获得折上折金币'
      //   case 1:
      //     return '参与平台活动获得折上折金币'
      //   case 2:
      //     return '折上折金币提现'
      //   case 3:
      //     return '退款成功，返还金币'
      // }
    },
 },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      recordValue: undefined,
      timeValue: undefined,
      accountMsg: {},
      goldList: [],
      query: {
        currentPage: 1,
        pageSize: 10,
        type: undefined,
        startTime: undefined,
        endTime: undefined,
        source: undefined,
      },
      recordOption: [
        { text: '所有记录', value: undefined },
        { text: '获取记录', value: 0 },
        { text: '使用记录', value: 1 },
      ],
      timeOption: [
        { text: '本月', value: 0 },
        { text: '2020年', value: 1 },
        { text: '2019年', value: 2 },
      ],
    }
  },
  created() {
    this.getAccount()
    this.getListTime()
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.loading = true
      list(this.query).then(({ data }) => {
        if (data.code === 200) {
          const total = data.data.page.totalCount
          this.goldList = this.goldList.concat(data.data.dataList)
          this.query.currentPage++
          this.loading = false
          // 数据全部加载完成

          if (this.goldList.length >= total) {
            this.finished = true
          }
        } else {
          this.error = true
          this.finished = true
        }
      })
      // .finally(() => {
      //   this.loading = false
      //   this.finished = true
      // })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.goldList = []
      this.query.currentPage = 1
      this.refreshing = false
      this.onLoad()
    },
    getAccount() {
      account().then(({ data }) => {
        if (data.code === 200) {
          this.accountMsg = data.data
          console.log('账户信息', this.accountMsg)
        }
      })
    },
    getTime(time) {
      return parseTime(time)
    },
    getListTime() {
      console.log('day', moment().year())
      let thisYear = moment().year()
      this.timeOption = []
      this.timeOption = [
        { text: '全部', value: undefined },
        { text: '本月', value: 0 },
        { text: '近三月', value: 1 },
      ]
      for (let i = thisYear; i >= 2020; i--) {
        this.timeOption.push({
          text: i + '年',
          value: i,
        })
      }
    },
    timeChange(val) {
      let startTime = moment().hours(0).minutes(0).seconds(0).milliseconds(0)
      let endTime = undefined
      if (val === undefined) {
        this.query.startTime = undefined
        this.query.endTime = undefined
      } else if (val === 0) {
        startTime = startTime.date(1)
        endTime = moment()
      } else if (val === 1) {
        startTime = startTime.subtract(2, 'month').date(1)
        endTime = moment()
      } else {
        startTime = startTime.year(val).month(0).date(1)
        endTime = moment()
          .year(val)
          .date(31)
          .hours(23)
          .minutes(59)
          .seconds(59)
          .milliseconds(0)
      }

      if (val !== undefined) {
        this.query.startTime = startTime.format('x')
        this.query.endTime = endTime.format('x')
      }

      this.query.currentPage = 1
      this.goldList = []
      this.finished = false
      this.onLoad()
    },
    recordChange(val) {
      console.log('val', val)
      this.query.type = val
      this.query.currentPage = 1
      this.goldList = []
      this.finished = false
      this.onLoad()
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
    onClickRight() {
      this.$router.push({
        path: '/gold-coin/gold-explain',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  padding: 15px 12.5px;
  background: #ff5660;
  height: 130px;
  text-align: center;
  .title {
    padding: 10px;
    text-align: left;
    margin-top: 15px;
    background: #fff;
    // width: 350px;
    height: 149px;
    border-radius: 8px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
    img {
      width: 34px;
      height: 34px;
    }
    .title-name {
      color: #6a3906;
      font-size: 15px;
    }
    .acquire {
      padding: 10px;
      display: flex;
      align-items: center;
      span {
        font-size: 24px;
      }
    }
  }
}
.list {
  .list-time {
    padding: 8px 12px;
    background: #eeeeee;
  }
  .list-header {
    display: flex;
    justify-content: space-between;
    color: #231815;
    border-bottom: 1px solid #eeeeee;
    padding: 10px 12px;
    .list-detail {
      align-items: center;
      p {
        margin: 0 0 10px 0;
        color: #666666;
      }
    }
  }
}
.list-mun {
  span {
    font-size: 18px;
  }
}
.number {
  min-width: 90px;
}
</style>